import React from "react";
import { Box, List, ListItem, Typography } from "@material-ui/core";
import Text from "../../../../shared/components/Text";
import DataDuoIcon from "../../../../../assets/summary/DataDuo.svg";
import IdFrontIcon from "../../../../../assets/summary/IdFront.svg";
import { useTheme } from "@material-ui/styles";
import { infoDataSEPAExplanation } from "../../../kyc/shared/config";
import InfoPanel from "../../../../shared/components/InfoPanel";

export default function Slide5({ isScreenXs, onBoardingByBorrower }) {
  const { palette } = useTheme();

  return (
    <>
      <Box
        mt={3}
        mx={2}
        className={"appear-anim"}
        display={"flex"}
        justifyContent={"space-between"}
        flexDirection={"column"}
      >
        <Box mb={2}>
          <Box display="flex" justifyContent="center" mb={2}>
            <Typography
              align="center"
              variant={isScreenXs ? "h6" : "h4"}
              style={{ color: palette.text.title }}
            >
              <strong>
                <Text tId="WHAT_WILL_YOU_NEED" />
              </strong>
            </Typography>
          </Box>
          <Typography
            align="center"
            variant={"subtitle1"}
            style={{
              color: palette.text.title,
              lineHeight: "1.4",
              marginTop: "0.25rem",
            }}
          >
            <strong>
              <Text tId="DOCUMENT_RECOMMENDATION" />
            </strong>
          </Typography>
        </Box>
        <Box>
          <List>
            <ListItem
              style={{
                alignItems: "start",
                padding: 0,
              }}
            >
              <img
                src={IdFrontIcon}
                height="50px"
                alt="image for valid document id"
              />
              <Box ml={3}>
                <Typography
                  variant={isScreenXs ? "subtitle2" : "subtitle1"}
                  style={{ color: palette.text.title }}
                >
                  <strong>
                    <Text tId="DNI_OR_NIE" />
                  </strong>
                </Typography>
                <Typography
                  variant={"body2"}
                  style={{ color: palette.text.title }}
                >
                  <Text tId="DNI_NIE_OR_PASSPORT_DOC" />
                </Typography>
              </Box>
            </ListItem>
          </List>
        </Box>
        <Box flex={0.7}>
          <List>
            <ListItem
              style={{
                alignItems: "start",
                padding: 0,
              }}
            >
              <img
                src={DataDuoIcon}
                height="50px"
                alt="image for bank account"
              />
              <Box ml={3}>
                <Typography
                  variant={isScreenXs ? "subtitle2" : "subtitle1"}
                  style={{ color: palette.text.title }}
                >
                  <strong>
                    {onBoardingByBorrower ? (
                      <Text tId="EUROPEAN_BANK_ACCOUNT" />
                    ) : (
                      <Text tId="INCOME" />
                    )}
                  </strong>
                </Typography>
                <Typography
                  variant={"body2"}
                  style={{ color: palette.text.title }}
                >
                  <Text tId="SEPA_PAYMENT_DETAILS" />
                </Typography>
              </Box>
            </ListItem>
          </List>
        </Box>
      </Box>
      <InfoPanel infoData={infoDataSEPAExplanation} />
    </>
  );
}
